import { render, staticRenderFns } from "./AddSubCategoryModal.vue?vue&type=template&id=4149c1fb"
import script from "./AddSubCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddSubCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports